import useTitle from 'hooks/useTitle';
import React, { useCallback, useMemo } from 'react';
import * as UserModels from 'models/users';
import useLoading from 'hooks/useLoading';
import usePromise from 'hooks/usePromise';
import RegistrationModel from 'models/users/registrationModel';
import UserResource from 'models/users/resource';
import ContentLoading from 'components/ContentLoading';
import AccessContext from './Context';
import AccessTable from './Table';

export const AllUsers = () => {
  useTitle('DigiTach: Admin brugere');

  // eslint-disable-next-line max-len
  const callback = useCallback(async (signal: AbortSignal) => (await UserModels.api.List(signal)).data, []);
  const [loading, setLoading] = useLoading();
  const [values, setValues] = usePromise(callback, [], setLoading);

  const registerUser = useCallback(async (binding: RegistrationModel) => {
    const result = await UserModels.api.Register(binding);

    setValues((prev) => [...prev, result.data]);
  }, []);

  const deleteUser = useCallback(async (resource: UserResource) => {
    await UserModels.api.Delete(resource.id);
    setValues((prev) => prev.filter((a) => a.id !== resource.id));
  }, []);

  const contextValue = useMemo(() => ({
    registerUser,
    deleteUser,
  }), [registerUser, deleteUser]);

  return (
    <AccessContext.Provider value={contextValue}>
      <ContentLoading loading={loading}>
        <AccessTable values={values} />
      </ContentLoading>
    </AccessContext.Provider>
  );
};

export default AllUsers;
